import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import RestaurantIcon from "@mui/icons-material/Restaurant"; // Ingredients
import StoreIcon from "@mui/icons-material/Store"; // Markets
import LocationOnIcon from "@mui/icons-material/LocationOn"; // Map Marks
import ArticleIcon from "@mui/icons-material/Article"; // Blogs
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag"; // Products
import MenuBookIcon from "@mui/icons-material/MenuBook"; // Recipes
import ChatIcon from "@mui/icons-material/Chat"; // Messages
import GroupIcon from "@mui/icons-material/Group"; // Team
import HelpOutlineIcon from "@mui/icons-material/HelpOutline"; // Faqs
import SettingsIcon from "@mui/icons-material/Settings"; // Configs
import CategoryIcon from "@mui/icons-material/Category"; // Categories

import { StyledLink, StyledListItemText } from './styled';

export const sidebarItems = [
  { id: 'Ingredients', label: "Ingredients", icon: <RestaurantIcon />, link: '/ingredients' },
  { id: 'Categories', label: "Categories", icon: <CategoryIcon />, link: '/categories' },
  { id: 'Markets', label: "Markets", icon: <StoreIcon />, link: '/markets' },
  { id: 'Map Marks', label: "Map Marks", icon: <LocationOnIcon />, link: '/map-marks' },
  { id: 'Blogs', label: "Blogs", icon: <ArticleIcon />, link: '/blogs' },
  { id: 'Products', label: "Products", icon: <ShoppingBagIcon />, link: '/products' },
  { id: 'Recipes', label: "Recipes", icon: <MenuBookIcon />, link: '/recipes' },
  { id: 'Messages', label: "Messages", icon: <ChatIcon />, link: '/messages' },
  { id: 'Team', label: "Team", icon: <GroupIcon />, link: '/teams' },
  { id: 'Faqs', label: "Faqs", icon: <HelpOutlineIcon />, link: '/faqs' },
  { id: 'Configs', label: "Configs", icon: <SettingsIcon />, link: '/configs' },
];

export const mainListItems = () => {
  return sidebarItems.map((item) => {
    return (
      <StyledLink key={item.id} to={item.link}>
        <ListItemButton>
          <ListItemIcon>
            {item.icon}
          </ListItemIcon>
          <StyledListItemText primary={item.label} />
        </ListItemButton>
      </StyledLink>
    )
  })
}
